export default "__VITE_PUBLIC_ASSET__7c94b786__"